<template>
    <Card
        :size="`col-md-10 col-lg-8 col-xl-6 max-xl-670`"
        :newLayout="true"
        :hideFooter="true"
    >
        <template slot="card-header">
            <h1 v-translate>Verify Your Account</h1>
        </template>
        <template slot="card-body">
            <div class="row justify-content-center text-size-base mb-2">
                <div class="col-md-8">
                    <p
                        class="text-standard"
                        v-translate="{ email: email }"
                    >
                        We have sent a verification email to %{ email }.
                    </p>
                    <p
                        class="text-standard"
                        v-translate
                    >
                        Please activate your account by clicking on the link in this mail. If you can't find the mail, please also check the Junk/Spam Folder.
                    </p>
                    <div class="input-group input-group--success mt-4">
                        <div class="input-group">
                            <span
                                class="input-group-text"
                                @click="sendVerificationEmail"
                                tabinex="0"
                                v-translate
                            >Resend</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-md-8">
                    <flash-message></flash-message>
                </div>
            </div>
        </template>
    </Card>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Card from '@C/Card.vue';
import FlashMessage from '@C/FlashMessage';
export default {
    name: 'VerifyAccount',
    mounted() {
        this.sendVerificationEmail();
    },
    computed: {
        ...mapState('Auth', ['email'])
    },
    methods: {
        ...mapActions({
            sendVerificationEmail: 'Auth/sendVerificationEmail'
        })
    },
    computed: {
        ...mapState('Auth', ['email'])
    },
    components: {
        Card,
        FlashMessage
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/stages/VerifyAccount.vue